import {env} from './env';

// Arc tables

export const AGENTS = `AGENTS${env}`;
export const BUCKETS = `BUCKETS${env}`;
export const BUYERS = `BUYERS${env}`;
export const FIRMS = `FIRMS${env}`;
export const HSC_TRACKING = `HSC_TRACKING${env}`;
export const LENDERS = `LENDERS${env}`;
export const PROPERTIES = `PROPERTIES${env}`;
export const PROPERTY_HISTORY = `PROPERTY_HISTORY${env}`;
export const SELLERS = `SELLERS${env}`;
export const STRIVE_ESCROW_TRACKING = `STRIVE_ESCROW_TRACKING${env}`;
export const TENANTS = `TENANTS${env}`;
export const UNDERWRITING_EXPENSES_CAMS = `UNDERWRITING_EXPENSES_CAMS${env}`;
export const UNDERWRITING_MULTI_TENANT = `UNDERWRITING_MULTI_TENANT${env}`;
export const UNDERWRITING_PARCELS = `UNDERWRITING_PARCELS${env}`;
export const UNDERWRITING_RENT_SCHEDULE = `UNDERWRITING_RENT_SCHEDULE${env}`;
export const UNDERWRITING_SINGLE_TENANT = `UNDERWRITING_SINGLE_TENANT${env}`;
export const UNDERWRITING_TENANTS = `UNDERWRITING_TENANTS${env}`;
export const UNDERWRITING_TENANT_TYPES = `UNDERWRITING_TENANT_TYPES${env}`;
//export const TEAM = 'TEAM';
export const TEAM = `TEAM${env}`;
export const TRAINING = `TRAINING${env}`;
export const TRAINING_CONTENT = `TRAINING_CONTENT${env}`;
export const HSC_LOAN_QUOTES = `HSC_LOAN_QUOTES${env}`;
export const PROPERTY_PAYMENT_TEAM = `PROPERTY_PAYMENT_TEAM${env}`
export const TERRITORIES_STNL = `TERRITORIES_STNL${env}`;
export const TERRITORIES_MTNL = `TERRITORIES_MTNL${env}`;
export const TERRITORIES = `TERRITORIES${env}`;
export const TEAM_MEMBER = `TEAM_MEMBER${env}`;
export const PROPOSAL =  `PROPOSAL${env}`;

// Arc email tables

export const EXPIRING_LISTINGS = `EXPIRING_LISTINGS${env}`;
export const INDUSTRIAL_BUYER = `INDUSTRIAL_BUYER${env}`;
export const IN_NEGOTIATION_PROPERTY_SERVICE = `IN_NEGOTIATION_PROPERTY_SERVICE${env}`;
export const NEW_ACTIVE_PROPERTIES = `NEW_ACTIVE_PROPERTIES${env}`;
export const NEW_CLOSED_PROPERTIES = `NEW_CLOSED_PROPERTIES${env}`;
export const OFFICE_BUYER = `OFFICE_BUYER${env}`;
export const RETAIL_MT_BUYER = `RETAIL_MT_BUYER${env}`;
export const RETAIL_STNL_BUYER = `RETAIL_STNL_BUYER${env}`;
export const TODAYS_EXPIRING_LISTINGS = `TODAYS_EXPIRING_LISTINGS${env}`;
export const UNDER_CONTRACT_PROPERTY_SERVICE = `UNDER_CONTRACT_PROPERTY_SERVICE${env}`;


// consts
export const OVERFLOW_TABLE_WIDTH = 125;
